/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Antenna} from "../models/antenna";
import {AntennaService} from "../services/antenna.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class AntennasResolver implements Resolve<Antenna[]> {

  constructor(
    private mAntennaService: AntennaService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Antenna[]> {
    try {
      return await this.mAntennaService.getAllAntennas();
    } catch (error) {
      console.error("Problem resolving Antennas... Error: " + error, error);
    }
  }

}
